import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/useTheme';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      onClick={toggleTheme}
      className="relative w-16 h-8 max-w-full bg-white/10 hover:bg-white/15 rounded-full transition-colors duration-300 border border-white/20"
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      {/* Background track */}
      <div className="absolute inset-0 rounded-full" />
      
      {/* Icons */}
      <div className="absolute inset-0 flex items-center justify-between px-2">
        <Sun 
          className={`w-4 h-4 transition-all duration-300 ${
            !isDark ? 'text-amber-400' : 'text-white/40'
          }`} 
        />
        <Moon 
          className={`w-4 h-4 transition-all duration-300 ${
            isDark ? 'text-blue-400' : 'text-white/40'
          }`} 
        />
      </div>
      
      {/* Sliding indicator */}
      <div
        className={`absolute top-1 w-6 h-6 bg-white rounded-full shadow-md transition-all duration-300 ${
          isDark ? 'left-9' : 'left-1'
        }`}
      />
    </button>
  );
};